<template>
  <div class="multiselect">
    <vt-combo-select
      ref="comboSelect"
      v-model="value"
      :options="params.options"
      :track-by="params.trackBy"
      :label="params.label"
      :custom-label="params.customLabel"
      :icon="params.icon"
      :max-height="120"
      :allow-empty="!params.required"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'VtSelectCellEditor',
    data() {
        return {
            value: null
        }
    },
    mounted() {
        this.value = this.params.value
        this.$nextTick(() => this.$refs.comboSelect.activateDropdown())
    },
    methods: {
        /* Component Editor Lifecycle methods */
        // the final value to send to the grid, on completion of editing
        getValue() {
            return this.value
        }
    }
})
</script>
